module.exports = __webpack_public_path__ + "img/Soudure tig sur structure mezzanine.acabac4e.jpg";